export enum AccountType {
  default = 'default',
  procurement = 'procurement',
  supplier = 'supplier',
  sio = 'sionet',
}
